import { SolutionMap, SolutionOptionKey } from "@labs/shared/types/Solution.ts";

export /**
 * Get the value of a solution option
 */
const getSolutionValuePercent = (
  solutionMap: SolutionMap,
  solutionKey: SolutionOptionKey,
) => solutionMap[solutionKey] || 0;
